<!-- Search Section -->
<div class="container mx-auto px-4 sm:px-6 lg:px-8 mb-6">
    <div class="relative">
        <!-- Search Input -->
        <div class="relative w-full" #searchContainer>
            <!-- Search Input -->
            <div class="relative">
              <span class="absolute inset-y-0 left-0 flex items-center pl-3">
                <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </span>
              <input
                type="text"
                (input)="search($event)"
                (focus)="showDropdown = true"
                placeholder="{{'SEARCH_PRODUCTS'|translate}}..."
                class="w-full pl-12 pr-4 py-3 text-gray-900 bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-200 placeholder-gray-400"
              />
              <button
                *ngIf="results.length > 0"
                (click)="clearSearch()"
                class="absolute inset-y-0 right-0 flex items-center pr-3"
              >
                <svg class="w-5 h-5 text-gray-400 hover:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
      
            <!-- Results Dropdown -->
            <div
              *ngIf="showDropdown && (results.length > 0 || loading)"
              class="absolute z-50 w-full mt-1 bg-white rounded-lg shadow-lg border border-gray-200 max-h-96 overflow-y-auto"
            >
              <!-- Loading State -->
              <div *ngIf="loading" class="p-4 text-center text-gray-500">
                <div class="animate-spin inline-block w-6 h-6 border-2 border-primary border-t-transparent rounded-full"></div>
                <p class="mt-2">Searching...</p>
              </div>
      
              <!-- No Results -->
              <div *ngIf="!loading && results.length === 0" class="p-4 text-center text-gray-500">
                No products found
              </div>
      
              <!-- Results List -->
              <div *ngIf="!loading && results.length > 0" class="py-2">
                <div
                  *ngFor="let hit of results"
                  (click)="selectProduct(hit)"
                  class="px-4 py-2 hover:bg-gray-50 cursor-pointer flex items-center gap-4"
                >
                  <!-- Product Image (if available) -->
                  <img
                    *ngIf="hit.images"
                    [src]="hit.images[0].thumbImage"
                    [alt]="hit.name"
                    class="w-12 h-12 object-cover rounded"
                  />
                  
                  <!-- Product Info -->
                  <div class="flex-1">
                    <!-- {{hit?.storeListings.length}} -->
                    <h3 class="text-md font-medium text-gray-900">{{hit?.brand}}</h3>
                    <h3 class="text-sm font-medium text-gray-500">{{(hit?.shortTitle) ? hit?.shortTitle : hit?.title}}</h3>
                    <!-- <p class="text-sm text-gray-500">{{ hit.description | slice:0:100 }}{{ hit.description?.length > 100 ? '...' : '' }}</p> -->
                    <div *ngIf="hit.storeListings.length && hit.storeListings[0]?.price">
                        <p class="text-sm font-medium text-secondary mt-1">{{ hit.storeListings[0]?.price | currency: 'EUR' }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

       
        <!-- <div class="relative">
            <div class="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
            </div>
            <button *ngIf="searchControl.value" (click)="clearSearch()"
                class="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-400 hover:text-gray-600 transition-colors duration-200">
                <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div> -->

        <!-- Loading State -->
        <div *ngIf="isLoading" class="absolute right-0 mr-12 top-1/2 transform -translate-y-1/2">
            <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-primary"></div>
        </div>
    </div>
</div>

<!-- Explore Categories -->
<div class="container mx-auto px-4 sm:px-6 lg:px-8 mb-8 sm:mb-12 relative z-20">
    <!-- <h2 class="text-2xl sm:text-3xl font-extrabold text-gray-900 mb-6 sm:mb-8 text-center">Explore Categories</h2> -->
    <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4 md:gap-6">
        <div class="group" *ngFor="let category of categories">
            <div class="relative overflow-hidden rounded-lg shadow-sm hover:shadow-md transition-all duration-300 ease-in-out transform hover:scale-105">
                <div class="relative pb-[75%] bg-gray-200">
                    <img *ngIf="category?.images?.length"
                         [src]="category?.images[0]?.image"
                         [alt]="category?.title"
                         (error)="error.handleImageError($event)"
                         class="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-300 group-hover:scale-110">
                    <div *ngIf="!category?.images?.length" 
                         class="absolute inset-0 flex items-center justify-center text-gray-500">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 sm:h-12 sm:w-12 md:h-16 md:w-16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                    </div>
                </div>
                <div class="absolute inset-0 bg-black bg-opacity-40 transition-opacity duration-300 opacity-0 group-hover:opacity-100"></div>
                <div class="absolute bottom-0 left-0 right-0 p-2 sm:p-3 md:p-4 text-white transform translate-y-full transition-transform duration-300 group-hover:translate-y-0">
                    <p class="text-xs sm:text-sm font-medium">
                        Explore our {{category?.title | lowercase}} collection
                    </p>
                </div>
                <a [routerLink]="['/store', category.slug]" class="absolute inset-0 z-10">
                    <span class="sr-only">View {{category?.title}} category</span>
                </a>
            </div>
            <h3 class="mt-2 sm:mt-3 text-sm sm:text-base md:text-lg font-semibold text-gray-900 group-hover:text-primary transition-colors duration-300 truncate">
                {{category?.title}}
            </h3>
        </div>
    </div>
</div>




